/*Component for the tabs on top of User spotlight page. Implemented to look
the same as the tabs on top of possible friend's page under components/Tribe/Friends/UserDetail/ProfileDetailTabs.js
*/

import React from "react";
import "./UserProfileDetailTabs.css";
import ButtonGroup from "react-bootstrap/ButtonGroup"
import BorderedButton from "components/General/Form/CustomButton/BorderedButton"
//API Doc: https://react-bootstrap.netlify.app/components/button-group/

class UserProfileDetailTabs extends React.Component {
  render() {
    return (
          <div className= "user-button-group">
              <ButtonGroup size = "lg" className = "tabbed_user">
                  {this.props.firstButtonIsActive === "true" ? (
                      <BorderedButton
                      //if the button is clicked, text is white rather than blue
                         handleOnClick = {this.props.firstButtonClick}
                         buttonClassName = "background_dark_bright_blue"
                         borderColor = "#30afc8"
                         title = {this.props.firstButtonText}
                         textClassName = "tab_label_text text_white"
                      />
                     ):(
                      <BorderedButton
                         handleOnClick = {this.props.firstButtonClick}
                         buttonClassName = "background_white"
                         borderColor = "#30afc8"
                         title = {this.props.firstButtonText}
                         textClassName = "tab_label_text text_dark_bright_blue"
                      />
                     )
                  }
                  {this.props.secondButtonIsActive === "true" ? (
                      <BorderedButton
                         handleOnClick = {this.props.secondButtonClick}
                         buttonClassName = "background_dark_bright_blue"
                         borderColor = "#30afc8"
                         title = {this.props.secondButtonText}
                         textClassName = "tab_label_text text_white"
                      />
                     ):(
                      <BorderedButton
                         handleOnClick = {this.props.secondButtonClick}
                         buttonClassName = "background_white"
                         borderColor = "#30afc8"
                         title = {this.props.secondButtonText}
                         textClassName = "tab_label_text text_dark_bright_blue"
                      />
                     )
                  }
                  {this.props.thirdButtonIsActive === "true" ? (
                      <BorderedButton
                         handleOnClick = {this.props.thirdButtonClick}
                         buttonClassName = "background_dark_bright_blue"
                         borderColor = "#30afc8"
                         title = {this.props.thirdButtonText}
                         textClassName = "tab_label_text text_white"
                      />
                     ):(
                      <BorderedButton
                         handleOnClick = {this.props.thirdButtonClick}
                         buttonClassName = "background_white"
                         borderColor = "#30afc8"
                         title = {this.props.thirdButtonText}
                         textClassName = "tab_label_text text_dark_bright_blue"
                      />
                     )
                  }
              </ButtonGroup>
          </div>
    )
  }
}

export default UserProfileDetailTabs;